import type { enBarcelona } from './en.barcelona';

/** Fase F (paquet barcelona): Barcelona, l’únic viatge a l’estranger. Les frases entre “cometes” són pràctica d’anglès i es queden en anglès. */
export const caBarcelona: typeof enBarcelona = {
  barcelona: {
    mapNames: { barcelona: 'Barcelona' },
    zones: {
      bc_city: 'Barcelona',
      bc_airport: 'Aeroport del Prat · arribades',
      bc_guell: 'Park Güell',
      bc_sagrada: 'Sagrada Família i l’Eixample',
      bc_rambla: 'La Rambla',
      bc_gotic: 'Barri Gòtic',
      bc_park: 'Parc de la Ciutadella',
      bc_beach: 'Port Vell i la Barceloneta',
    },
    objects: {
      bc_flight: 'Vol de tornada · El Prat',
      bc_aerobus: 'Parada de l’Aerobús (a plaça Catalunya)',
      bc_metroGuell: 'Metro L3 · Lesseps',
      bc_metroSagrada: 'Metro L5 · Sagrada Família',
      bc_metroLiceu: 'Metro L3 · Liceu',
      bc_metroBeach: 'Metro L4 · Barceloneta',
      bc_guellBench: 'Banc ondulat',
      bc_dragon: 'El drac',
      bc_sagrada: 'Sagrada Família',
      bc_canaletes: 'Font de Canaletes',
      bc_flowers: 'Quiosc de flors',
      bc_statue: 'Estàtua humana',
      bc_boqueria: 'Mercat de la Boqueria',
      bc_columbus: 'Monument a Colom',
      bc_cathedral: 'Catedral de Santa Eulàlia',
      bc_xurros: 'Parada de xurros amb xocolata',
      bc_castellers: 'Castellers (torre humana)',
      bc_petanca: 'Pista de petanca',
      bc_chiringuito: 'Xiringuito de platja',
    },
    npc: {
      bc_florist: 'Florista',
      bc_guide: 'Guia de la Sagrada Família',
      bc_waiter: 'Cambrer del xiringuito',
      bc_avi: 'Avi amb el pa',
      bc_tourist: 'Turista taiwanès perdut',
      bc_busker: 'Guitarrista de carrer',
      bc_sardanista: 'Sardanista',
      bc_petancaMan: 'Jugador de petanca',
      bc_juicer: 'Venedor de sucs',
      bc_kid: 'Nena amb patins',
      bc_staff: 'Informació de l’aeroport',
      bc_casteller: 'Cap de colla',
      bc_painter: 'Retratista',
    },
    items: {},

    metro: {
      text: 'Metro de Barcelona. Quina parada?',
      guell: '🟢 L3 · Lesseps (Park Güell)',
      sagrada: '🔵 L5 · Sagrada Família',
      liceu: '🟢 L3 · Liceu (La Rambla)',
      beach: '🟡 L4 · Barceloneta (platja)',
      airport: '🟠 L9 · Aeroport T1',
      riding: '🚇 Les portes es tanquen amb un xiulet… i som-hi.',
      fact: 'El metro de Barcelona va obrir el 1924, un dels més antics d’Espanya. Amb una T-casual tens deu viatges.',
    },
    aerobus: {
      text: 'L’Aerobús A1 va de la T1 a plaça Catalunya cada cinc minuts: uns 35 minuts fins al centre.',
      go: '🚌 Anar a plaça Catalunya',
      riding: 'L’autobús blau entra a l’autopista… Montjuïc a l’esquerra… plaça Catalunya!',
      arrived: 'Plaça Catalunya: els coloms, les fonts, i La Rambla comença just aquí i baixa fins al mar.',
    },

    sagrada: {
      text: 'La Sagrada Família: la basílica d’Antoni Gaudí. Les obres van començar el 1882 i ENCARA no s’han acabat: les grues formen part del paisatge. Quan estigui acabada tindrà 18 torres.',
      ask: '🗣️ Preguntar al guia (anglès)',
      q: 'Com preguntes al guia quan estarà acabada la basílica?',
      a: ['Excuse me, when will the basilica be finished?', 'Finish when basilica?', 'Basilica done now, yes?'],
      right: '“Good question! The tallest tower, for Jesus, should be ready soon — 172 metres, taller than any other church in the world.”',
      wrong: 'El guia somriu: “Try again — start with ‘Excuse me…’”',
      phrase: 'Excuse me, when will the basilica be finished?',
    },
    guellBench: {
      text: 'El banc ondulat de la plaça del Park Güell: 110 metres de corbes cobertes de trencadís, trossos de rajola trencada enganxats fent mosaics. Des d’aquí es veu tota la ciutat fins al mar.',
      sit: '🪑 Seure a mirar la ciutat',
      sat: 'Blau, groc, blanc… cada rajola té una forma diferent. A baix, les torres de la Sagrada Família treuen el cap per sobre dels terrats.',
      phrase: 'What a beautiful view!',
      q: 'Què és el “trencadís”?',
      a: ['Un mosaic fet amb rajoles trencades', 'Una mena de pa català', 'Un banc de fusta molt llarg'],
      right: 'Exacte! Gaudí feia servir les rajoles que les fàbriques llençaven. Res no es malbarata.',
      wrong: 'Mira el banc: està fet de milers de trossets trencats…',
    },
    dragon: {
      text: 'El drac: la salamandra de mosaic de l’escalinata, l’animal més fotografiat de Barcelona. De la boca li raja aigua cap a la pica.',
      photo: '📸 Fer la foto',
      done: 'Clic! Els altres esperen el seu torn… A Taiwan també hi ha molts dracs, però aquest va cobert de rajoles.',
      q: 'El drac en realitat és…',
      a: ['Una salamandra', 'Un cocodril', 'Un gat'],
      right: 'Una salamandra! A Gaudí li encantaven els animals i els va posar per tot el parc.',
      wrong: 'Fixa’t en les potes curtes i la cua llarga…',
    },
    canaletes: {
      text: 'La font de Canaletes, a dalt de tot de La Rambla. Diuen que qui en beu torna a Barcelona. Els aficionats del Barça celebren aquí les victòries.',
      drink: '🚰 Beure aigua',
      drank: 'Freda i fresca! Ara hauràs de tornar algun dia.',
      phrase: 'I will come back to Barcelona!',
    },
    statue: {
      text: 'Una estàtua humana: un home pintat de bronze, quiet del tot, fent de Colom. Tira-hi una moneda i… passa alguna cosa.',
      tip: '🪙 Tirar una moneda (2 monedes)',
      moved: 'L’estàtua parpelleja, fa una reverència i assenyala el mar amb un cruixit. I torna a quedar-se quieta!',
      poor: 'Avui no hi ha monedes per a l’estàtua.',
    },
    columbus: {
      text: 'El monument a Colom, de 60 metres, al final de La Rambla. Es va construir per a l’Exposició Universal de 1888. Colom assenyala el mar… cap a l’est, que ni tan sols és on hi ha Amèrica!',
      look: '🔭 Mirar on assenyala',
      q: 'Quin mar assenyala Colom?',
      a: ['El Mediterrani', 'El Pacífic', 'L’Atlàntic'],
      right: 'Sí! Barcelona és al mar Mediterrani. Taiwan és al Pacífic.',
      wrong: 'Mmm… el mar de Barcelona és càlid, blau i sense grans onades. Quin és?',
    },
    cathedral: {
      text: 'La catedral de Santa Eulàlia, construïda entre el 1298 i el 1420. Al claustre hi viuen tretze oques blanques, una per cada any de la curta vida de la santa.',
      geese: '🪿 Comptar les oques',
      q: 'Quantes oques viuen al claustre?',
      a: ['Tretze', 'Tres', 'Trenta'],
      right: 'Tretze, com els anys d’Eulàlia. I els diumenges es balla la sardana aquí mateix.',
      wrong: 'Tantes com anys va viure la santa: era molt jove…',
    },
    castellers: {
      text: 'Els castellers aixequen torres humanes de fins a deu pisos. La base és la pinya; el nen o nena que puja a dalt de tot és l’enxaneta i fa l’aleta quan el castell està complet.',
      cheer: '📣 Animar l’enxaneta',
      cheered: 'La plaça calla… l’enxaneta aixeca la mà… “Castell carregat!” Tothom aplaudeix. Després baixen amb la mateixa cura.',
      q: 'El lema dels castellers és “Força, equilibri, valor i seny”. Què vol dir “seny”?',
      a: ['Sensatesa', 'Soroll', 'Velocitat'],
      right: 'Sensatesa: anar amb compte i amb calma. Calen les quatre coses per aixecar un castell.',
      wrong: 'Pensa: què cal perquè ningú no caigui? Força, equilibri, valor… i…',
    },
    petanca: {
      text: 'Petanca: llança la bola d’acer tan a prop com puguis del bolig de fusta. Els avis hi juguen cada tarda.',
      throw: '🎯 Llançar una bola',
      result: (cm: number) => `La teva bola s’atura a ${cm} cm del bolig.`,
      great: 'La més a prop de totes! Els avis assenteixen: “molt bé”.',
      again: '🎯 Tornar a llançar',
    },

    flowers: {
      vendor: 'Hello! Roses, tulips, sunflowers — what would you like?',
      ok: 'One sunflower, please.',
      bad: ['Give flower.', 'Sunflower me want.'],
      done: '🌻 Un gira-sol embolicat amb paper. Tothom somriu en veure’l baixar per La Rambla.',
      price: 6,
    },
    boqueria: {
      text: 'La Boqueria: el mercat de Sant Josep, des del 1840. Gots de suc de tots els colors, pernil, fruita, peix… Aquí els mercats obren al matí i tanquen a la tarda.',
      closed: 'La Boqueria és tancada. Els mercats de Barcelona obren d’hora i tanquen a la tarda, al revés que els mercats nocturns de Taiwan!',
      juice: { vendor: 'Juices! Mango, strawberry, coconut, dragon fruit… which one?', ok: 'A mango juice, please.', bad: ['Mango juice now.', 'Juice of mango give.'], done: '🥭 Suc de mango gelat en got de paper. Un glop i la calor de La Rambla desapareix.', price: 4 },
      ham: { vendor: 'Jamón ibérico, cut thin — a paper cone for you?', ok: 'A cone of jamón, please.', bad: ['Jamón cone me.', 'Want jamón, cone.'], done: '🍖 Un cucurutxo de pernil, salat i tendre. A Espanya es talla a mà, tall a tall.', price: 8 },
      fruit: { vendor: 'Fresh fruit cups — melon, kiwi, strawberries!', ok: 'A fruit cup, please.', bad: ['Fruit cup, now!', 'Cup fruit I take.'], done: '🍓 Un got de fruita tallada amb una forquilleta de fusta. Dolç!', price: 5 },
    },
    xurros: {
      vendor: 'Churros with thick hot chocolate — breakfast or afternoon snack?',
      ok: 'Churros with chocolate, please.',
      bad: ['Churros chocolate give.', 'Me churros now.'],
      done: '🍫 Xurros cruixents sucats en una xocolata tan espessa que la cullera s’hi aguanta dreta. Aquí s’esmorzen… o es prenen a l’alba després d’una festa!',
      price: 6,
    },
    chiringuito: {
      text: 'Un xiringuito a la sorra: paella, crema catalana, orxata freda. A Espanya es dina a les dues o les tres i se sopa a les nou, molt més tard que a Taiwan!',
      noPaella: 'El cambrer: “Paella? Not yet — lunch here starts at two! Horchata or a crema catalana while you wait?”',
      paella: { vendor: 'Paella for one? Rice, prawns, mussels, a slice of lemon.', ok: 'A paella, please.', bad: ['Paella me.', 'Give paella now.'], done: '🥘 Arròs groc amb gambes i llimona, amb el mar al davant. El millor és la crosta del fons: el socarrat.', price: 18 },
      crema: { vendor: 'Crema catalana: custard with burnt sugar on top. Crack it with the spoon!', ok: 'A crema catalana, please.', bad: ['Crema give.', 'Catalana crema now.'], done: '🍮 Crac! El sucre es trenca com el vidre, i a sota és fred i cremós.', price: 6 },
      horchata: { vendor: 'Cold horchata — made from tiger nuts, very sweet.', ok: 'A horchata, please.', bad: ['Horchata me want.', 'Give horchata.'], done: '🥛 Dolça, freda i lletosa. No té res a veure amb la llet de soja de casa!', price: 4 },
    },

    talk: {
      bc_florist: [
        'Flors a La Rambla des del 1850! Per Sant Jordi, el 23 d’abril, tothom regala una rosa i un llibre. “A rose for you!”',
        'Les tulipes vénen d’Holanda; les roses, d’aquí. “Which one do you like?”',
      ],
      bc_guide: [
        'Gaudí deia: “La natura és la meva mestra”. Mira les columnes de dins: es ramifiquen com arbres. “Welcome to the Sagrada Família!”',
        'Gaudí hi va treballar 43 anys i és enterrat a la cripta. Les obres es paguen amb les entrades, sense diners del govern.',
      ],
      bc_waiter: [
        'Dinar? Abans de les dues, no; aquí ho fem així. I sopar a les nou o les deu! “Are you hungry?”',
        'Aquí paguem en euros, no en dòlars taiwanesos. Un euro són uns 35 dòlars de Taiwan, així que una paella són… molts dòlars! “The bill, please.”',
      ],
      bc_avi: [
        'Cada matí: una barra del forn i un cafè. Pa amb tomàquet: pa fregat amb tomàquet, oli i sal. Tasta’l! “Good morning!”',
        'Quan jo era petit pagàvem en pessetes. Després va arribar l’euro, el 2002. Ara ho compto tot dues vegades!',
      ],
      bc_busker: [
        '♪ Rumba catalana, la música dels carrers del Gòtic. Una moneda al barret i et toco la teva cançó. “Thank you, my friend!”',
        'Vaig aprendre amb aquesta guitarra del meu avi. La plaça té el millor eco de Barcelona.',
      ],
      bc_sardanista: [
        'La sardana: ens donem les mans en rotllana i comptem els passos, curts i llargs. Tothom hi pot entrar, tu també! “Come and dance!”',
        'La banda es diu cobla. La flauta aguda és el flabiol: el músic el toca amb una mà i un tamborí amb l’altra.',
      ],
      bc_petancaMan: [
        'Cada tarda, el mateix banc, els mateixos amics, les mateixes boles. El secret és al canell. “Your turn!”',
        'La petanca ve del sud de França, però aquí fa cent anys que hi juguem.',
      ],
      bc_juicer: [
        'Dos euros el got, tres el gran. Obrim a les vuit i tanquem a les tres: després anem a dinar a casa! “Fresh juice!”',
        'Pitaia, mango, pinya, coco… els colors es venen sols.',
      ],
      bc_kid: [
        'Patino tot el passeig, de l’hotel W al port, en dotze minuts! “Catch me if you can!”',
        'A l’estiu l’aigua és calenta fins a l’octubre. Avui? Una mica freda, però el pare diu que sóc de goma.',
      ],
      bc_staff: [
        'Benvingut a Barcelona! Aerobús al centre cada cinc minuts, o el metro L9. “Can I help you?”',
        'Tornes a casa? Els vols internacionals surten de la T1: passa el control aviat, l’aeroport de Barcelona és gran.',
      ],
      bc_casteller: [
        'Sóc el cap de colla: decideixo quin castell fem. Avui, un quatre de vuit. Vuit pisos, quatre persones a cadascun. “Up we go!”',
        'Els més forts van a baix, a la pinya, i el nen més lleuger a dalt. Cadascú té la seva feina.',
      ],
      bc_painter: [
        'Un retrat en deu minuts, a carbonet o pastel. He dibuixat turistes de quaranta països… i un de Taiwan: tu? “Sit down, please!”',
        'El difícil és el somriure. Tothom deixa de somriure al cap de tres minuts.',
      ],
    },
    tourist: {
      intro: '你好！請問，聖家堂怎麼走？我迷路了…\n\n(Hola! Perdona, com es va a la Sagrada Família? M’he perdut…)',
      help: '🗣️ Ajudar-lo en xinès',
      q: '怎麼回答他？ (Com li contestes?)',
      a: ['坐地鐵 L5 藍線，到 Sagrada Família 站下車。 (Agafa el metro blau L5 fins a Sagrada Família.)', '一直走到海邊。 (Continua caminant fins al mar.)', '坐飛機回台灣。 (Agafa un avió de tornada a Taiwan.)'],
      right: '「太好了，謝謝你！」Fa dues reverències, alleujat, i et regala un pastisset de pinya de la seva bossa. 🍍',
      wrong: '「海邊？」Mira el mapa, confós. La basílica és al nord, al costat del metro…',
    },
    hours: 'A Barcelona es dina a les 14 h i se sopa a les 21 h. Les botigues tanquen al migdia una bona estona i el mercat tanca a la tarda.',
  },
};
